// extracted by mini-css-extract-plugin
export default {"mil":"index_mil_XP4Gx"};